import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isOnlineOrderRecalculating = createSelector(
    onlineOrderState,
    onlineOrder => onlineOrder.recalculateRequest.isRecalculating || onlineOrder.voucherRequest.isVoucherAdding
);
